import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'
import { Message, MessageType } from '@tv3/store/message/message.model'
import { MessageForm } from '@tv3/interfaces/forms/message.form'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { MessagingChannelType } from '@tokeet-frontend/message'

export const LoadLatestMessages = createAction(
  '[Message] Load Latest Start',
  props<{ messageTypes: MessageType[]; lastDays: number; maxPages?: number }>()
)
export const LoadLatestMessagesComplete = createAction(
  '[Message] Load Latest Complete',
  props<{ messages: Message[] }>()
)

export const AddMessage = createAction(
  '[Message] Add Message',
  props<{ inquiry: Inquiry; form: MessageForm; channel?: MessagingChannelType }>()
)
export const AddMessageComplete = createAction('[Message] Add Message Complete', props<{ message: Message }>())

export const SendQuoteMessage = createAction(
  '[Message] Send Quote Message',
  props<{ inquiry: Inquiry; channel?: MessagingChannelType }>()
)

export const SendMessageToMultipleChannels = createAction(
  '[Message] Send Message to Channels',
  props<{ inquiry: Inquiry; form: MessageForm; channels?: MessagingChannelType[] }>()
)

export const GetMessagesByIds = createAction('[Message] Get Messages By Ids', props<{ messageIds: string[] }>())
export const GetMessagesByIdsComplete = createAction(
  '[Message] Get Messages By Ids Complete',
  props<{ messages: Message[] }>()
)

export const GetBookingMessages = createAction(
  '[Message] Get Booking Messages',
  props<{ bookingId: string; background?: boolean }>()
)
export const GetBookingMessagesComplete = createAction(
  '[Message] Get booking Messages Complete',
  props<{ bookingIds: string[]; messages: Message[] }>()
)

export const GetGuestMessages = createAction(
  '[Message] Get Guest Messages',
  props<{ guestId: string; background?: boolean }>()
)
export const GetGuestMessagesComplete = createAction(
  '[Message] Get Guest Messages Complete',
  props<{ messages: Message[]; guestId: string }>()
)

export const UpdateMessage = createAction('[Message] Update Message', props<{ messageId: string; payload: any }>())
export const UpdateMessageComplete = createAction(
  '[Message] Update Message Complete',
  props<{ update: Update<Message> }>()
)

export const DeleteMessage = createAction(
  '[Message] Delete Message',
  props<{ message: Message; inquiryId: string; silent?: boolean }>()
)
export const DeleteMessageComplete = createAction(
  '[Message] Delete Message Complete',
  props<{ message: Message; inquiryId: string }>()
)

export const RemoveMessageFromFeed = createAction('[Message] Remove Message from Feed', props<{ message: Message }>())
export const RemoveMessageFromFeedComplete = createAction(
  '[Message] Remove Message from Feed Complete',
  props<{ message: Message }>()
)

export const DeleteMessages = createAction(
  '[Message] Delete Messages',
  props<{ items: { message: Message; inquiryId: string }[]; silent?: boolean }>()
)
export const DeleteMessagesComplete = createAction(
  '[Message] Delete Messages Complete',
  props<{ items: { message: Message; inquiryId: string }[] }>()
)

export const RemoveMessagesFromFeed = createAction(
  '[Message] Remove Messages from Feed',
  props<{ messages: Message[] }>()
)
export const RemoveMessagesFromFeedComplete = createAction(
  '[Message] Remove Messages from Feed Complete',
  props<{ messages: Message[] }>()
)

export const MoveMessage = createAction('[Message] Move Message', props<{ toInquiryId: string; message: Message }>())
export const MoveMessageComplete = createAction('[Message] Move Message Complete', props<{ update: Update<Message> }>())

export const MoveMessagesInConversation = createAction(
  '[Message] Move Messages In Conversation',
  props<{ convoId: string; inquiryId: string; guestId?: string }>()
)
export const MoveMessagesInConversationComplete = createAction(
  '[Message] Move Messages In Conversation Complete',
  props<{ messages: Message[] }>()
)

export const MarkAsRead = createAction('[Message] Mark As Read', props<{ messageIds: string[] }>())
export const MarkAsReadComplete = createAction(
  '[Message] Mark As Read Complete',
  props<{ updates: Update<Message>[] }>()
)

export const MarkAsUnread = createAction('[Message] Mark As Unread', props<{ messageIds: string[] }>())
export const MarkAsUnreadComplete = createAction(
  '[Message] Mark As Unread Complete',
  props<{ updates: Update<Message>[] }>()
)

export const MarkOneMessageAsRead = createAction('[Message] Mark One Message As Read', props<{ messageId: string }>())
export const MarkOneMessageAsReadComplete = createAction(
  '[Message] Mark One Message As Read Complete',
  props<{ update: Update<Message> }>()
)

export const NewMessagesReceived = createAction('[Message] New Messages Received', props<{ messages: Message[] }>())

export const LoadUnreadCount = createAction('[Message] Load Unread Count')
export const LoadUnreadCountComplete = createAction('[Message] Load Unread Count Complete', props<{ count: number }>())
